// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-nav-group.lit.scss INSTEAD!
import { css } from 'lit';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-nav-item-item-gap=1.5rem] - gap between navigation bar items
   */
  --sh-nav-item-item-gap: 1.5rem;
  /* 
   * @cssprop [--sh-nav-item-active-stroke-transition=cubic-bezier(0.4, 0, 0.2, 1)] - speed of active stroke animation effect
   */
  --sh-nav-item-active-stroke-transition: cubic-bezier(0.4, 0, 0.2, 1);
  /* 
   * @cssprop [--sh-nav-item-height=3.5rem] - height of the nav item
   */
  --sh-nav-item-height: 3.5rem;
  /* 
   * @cssprop [--sh-nav-item-condensed-height=3rem] - height of the nav item in condensed mode
   */
  --sh-nav-item-condensed-height: 3rem;
  /* 
   * @cssprop [--sh-nav-item-label-min-width=1.5rem] - min-width of the nav item label
   */
  --sh-nav-item-label-min-width: 1.5rem;
  /* 
   * @cssprop [--sh-nav-item-slot-gap=0.25rem] - gap between label and slotted items
   */
  --sh-nav-item-slot-gap: 0.25rem;
  /* 
   * @cssprop [--sh-nav-item-label-line-height=1.25rem] - line-height of the nav item label
   */
  --sh-nav-item-label-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-nav-item-fade-width=2rem] - width of the fade effect on the left and right sides
   */
  --sh-nav-item-fade-width: 2rem;
  /* 
   * @cssprop [--sh-nav-item-active-stroke-gap=0.75rem] - gap between the nav item label and the active-stroke
   */
  --sh-nav-item-active-stroke-gap: 0.75rem;
  /* 
   * @cssprop [--sh-nav-item-active-stroke-gap-condensed=0.625rem] - gap between the nav item label and the active-stroke in condensed mode
   */
  --sh-nav-item-active-stroke-gap-condensed: 0.625rem;
  /* 
   * @cssprop [--sh-nav-item-right-slot-min-width=1rem] - min-width of the right slot
   */
  --sh-nav-item-right-slot-min-width: 1rem;
}

:host {
  display: flex;
  min-width: 0;
  min-height: var(--sh-nav-item-height);
  height: var(--sh-nav-item-height);
}

:host([condensed]) {
  min-height: var(--sh-nav-item-condensed-height);
  height: var(--sh-nav-item-condensed-height);
}

nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--sh-nav-item-item-gap);
  height: 100%;
}

.nav-container {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 0;
  flex: 1 1 0;
}
.nav-container.fade-left .nav-scroll {
  -webkit-mask-image: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-0)) 0%, rgba(var(--ui-1), var(--opacity-1)) var(--sh-nav-item-fade-width), rgba(var(--ui-1), var(--opacity-1)) 100%);
  mask-image: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-0)) 0%, rgba(var(--ui-1), var(--opacity-1)) var(--sh-nav-item-fade-width), rgba(var(--ui-1), var(--opacity-1)) 100%);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  -webkit-mask-position: 0 0;
  mask-position: 0 0;
}
.nav-container.fade-right .nav-scroll {
  -webkit-mask-image: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-1)) 0%, rgba(var(--ui-1), var(--opacity-1)) calc(100% - var(--sh-nav-item-fade-width)), rgba(var(--ui-1), var(--opacity-0)) 100%);
  mask-image: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-1)) 0%, rgba(var(--ui-1), var(--opacity-1)) calc(100% - var(--sh-nav-item-fade-width)), rgba(var(--ui-1), var(--opacity-0)) 100%);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  -webkit-mask-position: 0 0;
  mask-position: 0 0;
}
.nav-container.fade-left.fade-right .nav-scroll {
  -webkit-mask-image: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-0)) 0%, rgba(var(--ui-1), var(--opacity-1)) var(--sh-nav-item-fade-width), rgba(var(--ui-1), var(--opacity-1)) calc(100% - var(--sh-nav-item-fade-width)), rgba(var(--ui-1), var(--opacity-0)) 100%);
  mask-image: linear-gradient(90deg, rgba(var(--ui-1), var(--opacity-0)) 0%, rgba(var(--ui-1), var(--opacity-1)) var(--sh-nav-item-fade-width), rgba(var(--ui-1), var(--opacity-1)) calc(100% - var(--sh-nav-item-fade-width)), rgba(var(--ui-1), var(--opacity-0)) 100%);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  -webkit-mask-position: 0 0;
  mask-position: 0 0;
}

.nav-scroll {
  position: relative;
  overflow-x: auto;
  display: flex;
  scrollbar-width: none;
  min-width: 0;
  flex: 1 1 0;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.nav-scroll::-webkit-scrollbar {
  display: none;
}

.nav-scroll::after {
  content: "";
  position: absolute;
  bottom: var(--sh-nav-item-active-stroke-gap);
  left: var(--underline-left, 0);
  width: var(--underline-width, 0);
  height: 0.125rem;
  background-color: rgba(var(--ui-1), var(--opacity-950));
  pointer-events: none;
  transition: left 0s var(--sh-nav-item-active-stroke-transition);
  will-change: transform;
}

:host([condensed]) .nav-scroll::after {
  bottom: var(--sh-nav-item-active-stroke-gap-condensed);
}

.nav-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: rgba(var(--ui-1), var(--opacity-700));
  z-index: 3;
  transition: var(--transition-time) all ease-in-out;
}`;